import React, { useEffect, useState } from "react"
import { Outlet, useLocation } from "react-router-dom"
import useLearnerAuth from "../../auth/learner/useLearnerAuth"
import StudentSidebar from "../../component/student/StudentSidebar"
import StudentHeader from "../../component/student/StudentHeader"
import StudentBottomNav from "../../component/student/StudentBottomNav"
import { LearnerNotificationProvider } from "../../Context/LearnerNotification.context"
import "./StudentLayout.style.scss"

const SIDEBAR_COLLAPSED_KEY = "learner_sidebar_collapsed"

const readCollapsedPreference = (): boolean => {
  try {
    return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "1"
  } catch {
    return false
  }
}

const writeCollapsedPreference = (collapsed: boolean) => {
  try {
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, collapsed ? "1" : "0")
  } catch {
    /* ignore */
  }
}

const StudentLayout = () => {
  const location = useLocation()
  const { student } = useLearnerAuth()
  const [isCollapsed, setIsCollapsed] = useState(readCollapsedPreference)
  const [isSearchOpen, setIsSearchOpen] = useState(false)

  useEffect(() => {
    setIsSearchOpen(false)
  }, [location.pathname, location.search])

  const handleToggleCollapse = () => {
    setIsCollapsed((prev) => {
      const next = !prev
      writeCollapsedPreference(next)
      return next
    })
  }

  return (
    <LearnerNotificationProvider>
      <div data-theme="learner" className="student-layout">
        <StudentSidebar
          collapsed={isCollapsed}
          onToggleCollapse={handleToggleCollapse}
        />

        <div className="student-layout__main">
          <StudentHeader
            student={student}
            isSearchOpen={isSearchOpen}
            onToggleSearch={() => setIsSearchOpen((value) => !value)}
            onCloseSearch={() => setIsSearchOpen(false)}
          />

          <main className="student-layout__content">
            <div className="student-layout__content-inner">
              <Outlet context={{ student }} />
            </div>
          </main>

          <StudentBottomNav />
        </div>
      </div>
    </LearnerNotificationProvider>
  )
}

export default StudentLayout
